export default {
  // Register
  register: {
    createAccount: 'Create Account',
    createAccountDescription: 'Create an account to see courses approved in your state.',
    firstName: 'FIRST NAME',
    lastName: 'LAST NAME',
    emailAddress: 'EMAIL ADDRESS',
    username: 'USERNAME',
    usernameFilledFromEmail:
      'Username has been set to match your email. You can change it if you prefer.',
    password: 'PASSWORD',
    confirmPassword: 'CONFIRM PASSWORD',
    company: 'COMPANY',
    next: 'Next',
    country: 'COUNTRY',
    address: 'ADDRESS',
    address2: 'ADDRESS #2',
    city: 'CITY',
    state: 'STATE',
    zipCode: 'ZIP CODE',
    phone: 'PHONE #',
    fax: 'FAX #',
    selectOption: 'Select option',
    additionalInformation: 'ADDITIONAL INFORMATION',
    education: 'EDUCATION',
    experience: 'EXPERIENCE',
    gender: 'GENDER',
    birthYear: 'BIRTH YEAR',
    howDidYouHear: 'HOW DID YOU HEAR ABOUT US?',
    goBack: 'Go Back',
    submit: 'Submit',
    fixErrorsBelow: 'Please fix the following:',
    userType: 'I AM A',
    userTypeOptions: {
      homeowner: 'Homeowner',
      professional: 'Professional',
      both: 'Both'
    },
    // Dropdown option labels (Education)
    educationOptions: {
      highSchool: 'High School',
      someCollege: 'Some college',
      associateDegree: "Associate's degree",
      bachelorDegree: "Bachelor's degree",
      masterOrGreater: "Master's degree or greater",
      other: 'Other'
    },
    // Experience
    experienceOptions: {
      lessThan1Year: 'Less than 1 year',
      oneToFiveYears: '1-5 years',
      sixToTenYears: '6-10 years',
      tenYearsOrMore: '10 year or more'
    },
    // How did you hear about us
    howDidYouHearOptions: {
      radioAd: 'Radio ad',
      printAd: 'Print ad',
      tvAd: 'TV ad',
      directedByAgency: 'Directed by another agency',
      recommendedByFriend: 'Recommended by a friend',
      work: 'Work',
      other: 'Other'
    },
    // Gender
    genderOptions: {
      male: 'Male',
      female: 'Female',
      other: 'Other',
      preferNotToSay: 'Prefer not to say'
    }
  },

  // Forgot Password / Account Lookup
  forgotPassword: {
    accountLookup: 'Account Lookup',
    instruction: 'Enter the email address for your account. Login instructions will be e-mailed to you.',
    noEmailOnFile:
      "If you don't have an email address on file, contact your local training administrator for login assistance. If you do not know who your local administrator is, you may also email us at ",
    forAssistance: ' for assistance.',
    email: 'EMAIL:',
    send: 'Send'
  },

  // Login
  login: {
    pleaseSignIn: 'Please sign in',
    username: 'USERNAME:',
    password: 'PASSWORD:',
    submit: 'Submit',
    forgotUsernameOrPassword: 'Forgot your username or password?',
    dontHaveAccount: "Don't have an account?",
    createAccount: 'Create Account'
  },

  // Header
  header: {
    professional: 'Professional',
    homeowner: 'Homeowner',
    about: 'About',
    events: 'Events',
    training: 'Training',
    grants: 'Grants',
    logIn: 'Log In',
    createAccount: 'Create Account',
    dashboard: 'Dashboard',
    enEspanol: 'En Español'
  },

  // Sidebar
  sidebar: {
    info: 'Info',
    contactUs: 'Contact us',
    whatsNew: "What's new",
    community: 'Community',
    eventsCalendar: 'Events Calendar'
  },

  // 404 / Page Not Found (Safe Dig Indiana)
  notFound: {
    maintenanceMessage: "Pardon Our Dust — We're Hard at Work Beneath the Surface. Check back soon for our new learning experience!"
  },

  // Footer
  footer: {
    copyright: 'The materials on this website are copyright ©{year} Indiana Utility Regulatory Commission.',
    allRightsReserved: 'All rights reserved. All rights not expressly granted here are reserved.'
  },

  // Homeowners page (hero carousel)
  homeownersPage: {
    heroWelcomeTitle: 'Welcome Homeowners!',
    heroWelcomeSubtitle: 'Register and login to access your free safety training',
    loginRegister: 'Login/Register',
    heroSmellGasTitle: 'Smell Gas? Act Fast!',
    heroSmellGasSubtitle: 'Do you know what to do if you smell natural gas?',
    learnMore: 'Learn More',
    heroPlantingTitle: 'Planting a Tree? Fencing? New Mailbox?',
    heroPlantingSubtitle: 'You never know what might be below, Contact 811 before getting to work',
    indiana811: 'Indiana 811'
  },

  // Professionals page
  professionalsPage: {
    learnMore: 'Learn More',
    requestDigTicket: 'Request Your Dig Ticket',
    requestDigTicketDescription: "Your first stop when you're getting ready to dig.",
    onlineTicketEntry: 'Online Ticket Entry',
    heroWelcomeTitle: 'Welcome Utility Professional!',
    heroWelcomeSubtitle: 'Register and login to access your free safety training.',
    loginRegister: 'Login/Register',
    viewCourse: 'View Course'
  },

  // Homepage
  homepage: {
    welcomeTo: 'Welcome to',
    safeDigIndiana: 'Safe Dig Indiana',
    heroText: 'The Indiana Utility Regulatory Commission, through the Underground Plant Protection Account, is dedicated to reducing damages to underground facilities and keeping Hoosiers safely connected to their utility services through training, outreach, and education.',
    pleaseSelectYourPage: 'PLEASE SELECT YOUR PAGE',
    professionals: 'PROFESSIONALS',
    homeowners: 'HOMEOWNERS',
    accessYourTraining: 'ACCESS YOUR TRAINING',
    helpfulLinks: 'HELPFUL LINKS',
    notify811: 'Notify 811',
    notify811Description: "Your first stop when you're getting ready to dig.",
    siteProfessionals: 'Professionals',
    homeownersLabel: 'Homeowners',
    pipelineDamagesMap: 'Pipeline Damages Map',
    pipelineDamagesMapDescription: 'View utility safety trainings, meetings, and other events',
    useTheMap: 'Use the map',
    eventsCalendar: 'Events Calendar',
    eventsCalendarDescription: 'View utility safety trainings, meetings, and other events',
    upcomingEvents: 'Upcoming Events'
  },

  // Contact Us
  contactUs: {
    title: 'If you have any question about the site, please contact us.',
    intro: 'The IURC is here to help with any questions regarding course content or to clarify any questions on excavation laws.',
    toContactIurc: 'To contact the IURC:',
    email: 'Email:',
    importantLegalInfo: 'Important legal information',
    overview: 'Overview',
    overviewText: 'By using this website, you agree to be bound by these terms of use. The Indiana Utility Regulatory Commission may modify these terms at any time. The IURC reserves the right to seek all remedies available at law and in equity for violations of these terms.',
    copyrightInfo: 'Copyright information',
    copyrightText: 'All content on this website is protected by United States and international copyright laws and treaties. No part of the website may be copied, altered, distributed, transmitted, performed, displayed, or used in any way without prior written permission from the Indiana Utility Regulatory Commission.',
    trademarkTitle: 'Trademark information',
    trademarkText: 'The Safe Dig Indiana names and logos and all related product and service names are marks or registered marks of the Indiana Utility Regulatory Commission and are the property of the Indiana Utility Regulatory Commission.',
    useOfInfoTitle: 'Use of information',
    useOfInfoText: 'The Indiana Utility Regulatory Commission hereby authorizes you to view, copy, print and distribute materials available on this website provided that (1) the materials are used for non- commercial, internal informational purposes only; (2) the above copyright notice appears on every copy of the material and any portion thereof; and (3) no materials or related graphics are modified or altered in any way. Any rights not expressly granted herein are reserved by the Indiana Utility Regulatory Commission.',
    complianceTitle: 'Compliance with applicable laws',
    complianceText: 'All applicable federal, state and local laws govern user access to this website.',
    disclaimerTitle: 'Disclaimer of warranty',
    disclaimerText: 'Although the Indiana Utility Regulatory Commission attempts to provide useful information, the Indiana Utility Regulatory Commission assumes no responsibility for the accuracy or completeness of the information or the suitability of any advice, opinion, statement or other information displayed or distributed through this website. This information could contain technical inaccuracies or typographical errors, and information can be changed, updated and deleted without notice. In addition, the Indiana Utility Regulatory Commission assumes no obligation to update or to continue to post the information. ALL INFORMATION PROVIDED ON OR THROUGH THIS WEBSITE IS PROVIDED "AS IS" WITH NO WARRANTIES OF ANY KIND WHATSOEVER, EITHER EXPRESSED OR IMPLIED.',
    limitationTitle: 'Limitation of liability',
    limitationText: 'IN NO EVENT WILL THE INDIANA UTILITY REGULATORY COMMISSION BE LIABLE TO ANY PARTY FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, CONSEQUENTIAL OR PUNITIVE DAMAGES FOR USE OF THIS SITE INCLUDING, WITHOUT LIMITATION, LOST PROFITS OR REVENUES, COSTS OF REPLACEMENT PRODUCTS, BUSINESS INTERRUPTIONS, LOSS OF DATA OR DAMAGES RESULTING FROM USE OF OR RELIANCE ON THE INFORMATION PRESENT.',
    jurisdictionTitle: 'Jurisdiction',
    jurisdictionText: 'The Indiana Utility Regulatory Commission controls and operates this website through its vendor in the State of Indiana. The Indiana Utility Regulatory Commission does not imply that the materials published on this website are appropriate for use outside of Indiana. If you access this website from outside of Indiana, you do so on your own initiative and are responsible for compliance with local laws. The terms of this website shall be governed by the laws of the state of Indiana.',
    revisionsTitle: 'Revisions',
    revisionsText: 'The Indiana Utility Regulatory Commission may terminate, change, suspend or discontinue any aspect of this website, including the availability of any features of the site, at any time and without notice. The Indiana Utility Regulatory Commission reserves the right, at its sole discretion, to change, modify, add or remove any portion of these terms in whole or in part, at any time and without notice. The Indiana Utility Regulatory Commission may terminate the authorization, rights and license given above at any time and without notice. Your continued use of this website after any changes to these terms are posted will be considered acceptance of those changes.',
    consentsTitle: 'Consents',
    consentsTextBefore: 'Requests for the Indiana Utility Regulatory Commission\'s consents or approvals should be made in writing and directed to',
    consentsTextAfter: 'or:',
    consentsAddress: 'Indiana Utility Regulatory Commission\nAttention: Beth Heline, General Counsel\n101 West Washington Street, Suite 1500 E\nIndianapolis, IN 46204'
  },

  // Community / Associations
  community: {
    title: 'Associations',
    associations: {
      iurc: 'Indiana Utility Regulatory Commission (IURC)',
      cga: 'Common Ground Alliance (CGA)',
      uppa: 'Underground Plant Protection Account (UPPA)',
      holidaySchedule: 'Indiana 811 Holiday Schedule',
      indiana811: 'Indiana 811',
      damagePreventionCouncils: 'Indiana Damage Prevention Councils (DPCs)',
      damageToUnderground: 'Damage to Underground Facilities',
      inpaa: 'Indiana Pipeline Awareness Association (INPAA)'
    }
  },

  // What's New
  whatsNew: {
    title: "What's New",
    welcomeTitle: 'Welcome to Safe Dig Indiana',
    welcomePara1: "Welcome to Indiana's free, online utility safety training system!",
    welcomePara2: 'The Indiana Utility Regulatory Commission has created this free training resource for anyone who works in excavation to learn more about working safely in Indiana. Currently, the available courses will teach excavators about the Indiana Dig Law and how that law affects your jobsite, including how the 811 system works and how to use 811 most efficiently.',
    welcomePara3: 'Make sure to visit the Resources section for more information that can help you stay safe and keep your job on track. You are encouraged to print out and keep any information you believe can help keep your jobs moving safely and efficiently.',
    welcomePara4Before: 'Check back frequently for new updates to the available resources and new training opportunities. If you have a suggestion for content you would like to see added, please contact the IURC ',
    welcomePara4After: '.',
    contactHere: 'here'
  },

  // Events
  events: {
    title: 'Events Calendar',
    pageTitle: 'Events',
    intro: 'View utility safety trainings, meetings, and other events.',
    noEventsMessage: 'There are no events scheduled at this time.',
    daysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  },

  // Grants
  grants: {
    heroTitle: 'The UPPA Fund',
    heroSubtitle: 'Do you have an idea that would improve utility safety? Request a grant from the UPPA fund!',
    intro: "The UPP Account Grant is available to anyone looking to improve the safety of Indiana's communities by protecting underground facilities through: public awareness, training and education, or incentive programs.",
    completingApplication: 'Completing the Application',
    downloadInstruction: 'Download the {appLink} and the {instructionsLink} using the links below.',
    uppaGrantApp: 'UPP Account Grant Application',
    uppaGrantInstructions: 'UPP Account Grant Application Instructions',
    btnGrantApp: 'UPPA GRANT REQUEST APPLICATION',
    btnGrantInstructions: 'UPPA GRANT REQUEST INSTRUCTIONS',
    note: 'When you submit your grant request, do not submit as a PDF.',
    fillOutFields: 'Please fill out all fields completely in as much detail as possible. The start date for any proposed event must be after the date you send in the application. Applications for events that have already occurred may not be approved.',
    questionsDirectTo: 'Questions regarding your application should be directed to Underground Plant Protection Account Fund Program Manager Darby Miller at {email}. Legal questions may be directed to the General Counsel\'s Office at {legalEmail}.',
    completedTo: 'Completed applications should be emailed to the Underground Plant Protection Account Program Manager, at {email}.',
    grantingOfFunds: 'Granting of Funds',
    grantingPara1: 'Your completion of this grant application does not guarantee that the IURC shall award grant funds. Should the IURC provide a grant award, it will do so in writing. The IURC shall make every attempt to respond to application requests within thirty days.',
    grantingPara2: 'Applicants shall be required to enter into a fully executed Grant agreement prior to the provision of Underground Plant Protection Account funds.',
    grantingPara3: 'Please note that due to state procurement rules, a grant agreement is not necessary for grants of $5,000 or less. However, the IURC still requires a completed and approved grant application.',
    grantingPara4: 'In order to be able to pay a grant or contract, the requestor must be entered into the State of Indiana payment system. This will require a properly completed W-9 and Direct Deposit Form.',
    clickHere: 'Click here',
    clickHereLink: '{link} to be directed to the IURC\'s Grant Request page for the most up-to-date W-9 and Direct Deposit forms.'
  }
};
